// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HYS2","content":"styles_content__2QeVu","tableWrap":"styles_tableWrap__2adjP"};